<ng-template cdkPortalOutlet></ng-template>


// WEBPACK FOOTER //
// ./node_modules/ng-pick-datetime/dialog/dialog-container.component.d.ts.OwlDialogContainerComponent.html